/**
 * Formats time elapsed since a reference point as `+m:ss.t`, or `+h:mm:ss`
 * once past an hour. Negative inputs clamp to zero.
 */
export function formatElapsedMs(elapsedMs: number): string {
    const totalTenths = Math.max(0, Math.round(elapsedMs / 100));
    const tenths = totalTenths % 10;
    const totalSeconds = Math.floor(totalTenths / 10);
    const seconds = totalSeconds % 60;
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const hours = Math.floor(totalSeconds / 3600);
    if (hours > 0) {
        return `+${hours}:${pad2(minutes)}:${pad2(seconds)}`;
    }
    return `+${minutes}:${pad2(seconds)}.${tenths}`;
}

function pad2(value: number): string {
    return String(value).padStart(2, '0');
}
